const planObraSocialInitialState = {
    planObraSocial: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default planObraSocialInitialState;